import { render, staticRenderFns } from "./CoursesettlementList.vue?vue&type=template&id=f9fb0b54&scoped=true"
import script from "./CoursesettlementList.vue?vue&type=script&lang=js"
export * from "./CoursesettlementList.vue?vue&type=script&lang=js"
import style0 from "./CoursesettlementList.vue?vue&type=style&index=0&id=f9fb0b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fb0b54",
  null
  
)

export default component.exports